import { getSharedIconBoxStyle } from './shared-icon-box-style';
import { ellipsisText } from './shared-ellipsis-text-style';

export const getInfoPaneItemRenameStyle = (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' } = {}) => ({
  nameContentBox: {
    position: 'relative',
  },
  nameBox: {
    width: '100%',
  },
  editNameBox: {
    paddingBottom: '16px',
  },
  editWrapper: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: iconFontFamily,
  },
  editContent: {
    fontFamily: 'Segoe UI',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '19px',
    color: '#484644',
    marginRight: 16,
    wordBreak: 'break-all',
    ...ellipsisText(),
  },
  icon: {
    color: palette.themePrimary,
    fontSize: '16px',
    lineHeight: '16px',
    padding: 0,
    background: 'transparent',
    border: 'none',
    pointerEvents: 'auto',
  },
  editIcon: {
    '&:before': {
      content: '"\\E70F"',
    },
  },
  addNameBox: {
    ...getSharedIconBoxStyle({ palette }),
    width: 146,
    marginTop: 4,
    marginBottom: 16,
  },
  addIcon: {
    fontFamily: iconFontFamily,
    color: palette.themeDarkAlt,
    '&:before': {
      content: '"\\E710"',
    },
  },
  addText: {
    marginLeft: '8px',
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
    color: palette.themeDarkAlt,
  },
  textField: {
    width: 300,
    marginRight: 12,
  },
  completeIcon: {
    marginRight: 16,
    '&:before': {
      content: '"\\E8FB"',
    },
  },
  cancelIcon: {
    '&:before': {
      content: '"\\E711"',
    },
  },
  disabledIcon: {
    color: palette.neutralTertiary,
  },
});
